// @flow
export const prefix = '@@redux-form/'

export const ARRAY_INSERT = `${prefix}ARRAY_INSERT`
export const ARRAY_MOVE = `${prefix}ARRAY_MOVE`
export const ARRAY_POP = `${prefix}ARRAY_POP`
export const ARRAY_PUSH = `${prefix}ARRAY_PUSH`
export const ARRAY_REMOVE = `${prefix}ARRAY_REMOVE`
export const ARRAY_REMOVE_ALL = `${prefix}ARRAY_REMOVE_ALL`
export const ARRAY_SHIFT = `${prefix}ARRAY_SHIFT`
export const ARRAY_SPLICE = `${prefix}ARRAY_SPLICE`
export const ARRAY_UNSHIFT = `${prefix}ARRAY_UNSHIFT`
export const ARRAY_SWAP = `${prefix}ARRAY_SWAP`
export const AUTOFILL = `${prefix}AUTOFILL`
export const BLUR = `${prefix}BLUR`
export const CHANGE = `${prefix}CHANGE`
export const CLEAR_FIELDS = `${prefix}CLEAR_FIELDS`
export const CLEAR_SUBMIT = `${prefix}CLEAR_SUBMIT`
export const CLEAR_SUBMIT_ERRORS = `${prefix}CLEAR_SUBMIT_ERRORS`
export const CLEAR_ASYNC_ERROR = `${prefix}CLEAR_ASYNC_ERROR`
export const DESTROY = `${prefix}DESTROY`
export const FOCUS = `${prefix}FOCUS`
export const INITIALIZE = `${prefix}INITIALIZE`
export const REGISTER_FIELD = `${prefix}REGISTER_FIELD`
export const RESET = `${prefix}RESET`
export const RESET_SECTION = `${prefix}RESET_SECTION`
export const SET_SUBMIT_FAILED = `${prefix}SET_SUBMIT_FAILED`
export const SET_SUBMIT_SUCCEEDED = `${prefix}SET_SUBMIT_SUCCEEDED`
export const START_ASYNC_VALIDATION = `${prefix}START_ASYNC_VALIDATION`
export const START_SUBMIT = `${prefix}START_SUBMIT`
export const STOP_ASYNC_VALIDATION = `${prefix}STOP_ASYNC_VALIDATION`
export const STOP_SUBMIT = `${prefix}STOP_SUBMIT`
export const SUBMIT = `${prefix}SUBMIT`
export const TOUCH = `${prefix}TOUCH`
export const UNREGISTER_FIELD = `${prefix}UNREGISTER_FIELD`
export const UNTOUCH = `${prefix}UNTOUCH`
export const UPDATE_SYNC_ERRORS = `${prefix}UPDATE_SYNC_ERRORS`
export const UPDATE_SYNC_WARNINGS = `${prefix}UPDATE_SYNC_WARNINGS`

export default {
  ARRAY_INSERT,
  ARRAY_MOVE,
  ARRAY_POP,
  ARRAY_PUSH,
  ARRAY_REMOVE,
  ARRAY_REMOVE_ALL,
  ARRAY_SHIFT,
  ARRAY_SPLICE,
  ARRAY_UNSHIFT,
  ARRAY_SWAP,
  AUTOFILL,
  BLUR,
  CHANGE,
  CLEAR_FIELDS,
  CLEAR_SUBMIT,
  CLEAR_SUBMIT_ERRORS,
  CLEAR_ASYNC_ERROR,
  DESTROY,
  FOCUS,
  INITIALIZE,
  REGISTER_FIELD,
  RESET,
  RESET_SECTION,
  SET_SUBMIT_FAILED,
  SET_SUBMIT_SUCCEEDED,
  START_ASYNC_VALIDATION,
  START_SUBMIT,
  STOP_ASYNC_VALIDATION,
  STOP_SUBMIT,
  SUBMIT,
  TOUCH,
  UNREGISTER_FIELD,
  UNTOUCH,
  UPDATE_SYNC_ERRORS,
  UPDATE_SYNC_WARNINGS
}
